import React from 'react';
import { Button } from "@material-ui/core";
import './empty-state.css';

const EmptyState = ({ icon: Icon, iconSize = 48, title, description, actionLabel, actionIcon: ActionIcon, onAction }) => {
	return (
		<div className="empty-state">
			{Icon && <Icon size={iconSize} className="empty-state__icon" />}
			{title && <p className="empty-state__title">{title}</p>}
			{description && <p className="empty-state__description">{description}</p>}
			{actionLabel && onAction && (
				<Button
					variant="outlined"
					color="primary"
					size="large"
					onClick={onAction}
					className="empty-state__btn"
					startIcon={ActionIcon ? <ActionIcon size={22} /> : null}
				>
					{actionLabel}
				</Button>
			)}
		</div>
	);
};

export default EmptyState;
